import axios from "axios";
import { setAuthorization } from "../../../helpers/api_helper";
import { jwtDecode } from "jwt-decode";

const AUTHORITIES = ['ADMIN', 'SUPER_ADMIN'];

export const authUser = async (data) => {
    try {
        const response = await axios.post(`${process.env.REACT_APP_API_URL}/auth/login`, data, {
            headers: {
                'Content-Type': 'application/json'
            },
        });
        if (response) setAuthorization(response.token);
            
        const token_parsed = jwtDecode(response.token);
        const roles = token_parsed.realm_access.roles.filter((item) => item === 'SUPER_ADMIN' || item === 'ADMIN');

        if (AUTHORITIES.some(r => roles.includes(r))) {
            saveUserToSessionStorage({
                token: response.token,
                ...token_parsed,
                roles
            });
            
            return { roles, isAuthorized: true };
        } else {
            return { roles, isAuthorized: false };
        }
    } catch (e) {
        // console.log('e', e) à améliorer apres
        if (!e.response) {
            return Promise.reject("Problème de connexion. Vérifiez votre réseau et réessayez.");
        }
        if (e.response.status === 401) {
            return Promise.reject("Oups !!! Vous n'êtes pas autorisé à vous connecter. Vérifiez vos identifiants.");
        }
        if (e.response.status === 403) {
            return Promise.reject("Accès interdit. Vous n'avez pas les autorisations nécessaires.");
        }
        if (e.response.status === 500) {
            return Promise.reject("Erreur serveur.");
        }
        return Promise.reject("Une erreur est survenue lors de la connexion. Veuillez réessayer.");
    }
}

export const saveUserToSessionStorage = (user) => {
    if (user) {
        sessionStorage.setItem('authUser', JSON.stringify({
            token: user.token,
            fullName: user.name,
            email: user.email,
            roles: user.roles,
            company: user.company,
            companyName: user.companyName || user.company,
            superAdminId: user.superAdminId,
            userId: user.userId,
            isSuperAdmin: !!user.roles.includes('SUPER_ADMIN')
        }));
    }
}

export const logout = () => {
    sessionStorage.clear();
    return true;
}

export const updatePassword = async (data) => {
    const email = data?.email;
    const newPassword = data?.newPassword;
    try {
        const response = await axios.put(
            `auth/${data?.email}/newPassword?email=${encodeURIComponent(data?.email)}&newPassword=${encodeURIComponent(newPassword)}`
          );
        return response;
    } catch (error) {
        throw error;
    }
};
